module.exports = __webpack_public_path__ + "static/media/access_227.96598ef7.ico";